import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker, { DateObject } from "react-multi-date-picker";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddRedeem = ({ show, onClose, refresh }) => {
    const branch_id = parseInt(localStorage.getItem("branch_id"), 10);

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const coupon_type = [
        { value: 0, label: "Amount" },
        { value: 1, label: "Percentage" }
    ];

    // Input datas
    const [coupon_name, setname] = useState(null);
    const [couponType, setCouponType] = useState(null);
    const [couponValue, setCouponValue] = useState('');
    // const [endDate, setEndDate] = useState(null);
    // const [endDatedisp, setEndDateDisp] = useState(null);

    const handleCouponTypechange = (selectedOptions) => {
        setCouponType(selectedOptions.value);
    }

    const [data_name, setData] = useState([]);
    useEffect(() => {
        axios.get(`${baseURL}/redeem`, {params:{branch_id}})
          .then(response => {
            setData(response.data.data.map(mode => mode.points.toLowerCase()));
          })
          .catch(error => {
            console.log('There was an error fetching the data!', error);
          });
    }, [])

    function formatCouponValue(value) {
        if (value === undefined || value === null || value === '') {
            return 0; // or handle required validation elsewhere
        }

        // Try to convert to a number
        let num = Number(value);

        if (isNaN(num)) {
            // If not a number, return null or handle error
            return 0;
        }

        // Check if number is decimal (has fractional part)
        if (!Number.isInteger(num)) {
            // Round to 2 decimal places
            num = Math.round(num * 100) / 100;
        } else {
            // It's an integer, just pass as is (or convert to int explicitly)
            num = parseInt(num, 10);
        }

        return num;
    }

    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};

        if (!coupon_name) {
            newErrors.name = "This Field is Required.";
        } else if (data_name.includes(coupon_name.trim().toLowerCase())) {
            newErrors.name = "This Point Already Exists.";
        }
        
        if (couponType === null) {
            newErrors.typ = "This Field is Required.";
        }

        if (!couponValue) {
            newErrors.typ = "This Field is Required.";
        }

        
        // if (all_coupon_code.includes(couponCode.trim().toLocaleLowerCase())){
        //     newErrors.code = "The Coupon Code Already Exist.";
        // }

        // if (!endDate) {
        //     newErrors.endDate = "This Field is Required.";
        // }

        return newErrors;
    };

    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const formattedValue = formatCouponValue(couponValue);
        let post = {
            points: parseFloat(coupon_name),
            value: formattedValue,
            value_type: couponType,
            created_by: user_id,
            branch_id: branch_id
        }

        axios.post(`${baseURL}/redeem`, post)
            .then(response => {
                onClose();
                refresh();
                toast.success("Redeem Points Created successfully!");
            }).catch(error => {
                onClose();
                console.log(error);
                toast.error("Redeem Points Creation Failed");
            });
    };


    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Create Redeem Points</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Redeem Point<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter redeem Point" 
                                    maxLength={100}
                                    value={coupon_name} 
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setname(onlyNums);
                                    }}
                                />
                                {errors.name && <div className="text-danger fs-8 mt-1">{errors.name}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Redeem Value<span className="required">*</span></label>
                                <div className='row'>
                                    <div className='col-lg-6'>
                                        <input type="text" className="form-control" placeholder="Enter Redeem Value" 
                                            maxLength={9}
                                            value={couponValue} 
                                            onChange={(e) => {
                                                const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                                setCouponValue(onlyNums);
                                            }}
                                        />
                                    </div>
                                    <div className='col-lg-6'>
                                        <Select
                                            onChange={handleCouponTypechange}
                                            options={coupon_type}
                                            placeholder="Select Type"
                                        />
                                    </div>
                                    {errors.typ && <div className="text-danger fs-8 mt-1">{errors.typ}</div>}
                                </div>
                            </div>
                            
                            {/* <div className="col-lg-6 mb-2">
                                <label className="text-black font-w500 fs-7">End Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        value={endDatedisp}
                                        onChange={(date) => {
                                            handleStartDateChange(date);
                                        }}
                                        format="DD-MM-YYYY"
                                    />
                                </div>
                                {errors.endDate && <div className="text-danger fs-8 mt-1">{errors.endDate}</div>}
                            </div> */}
                        </div>
                        <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
                            <button type="submit" className="btn btn-sm btn-primary" >Create Redeem Points<i className="fas fa-angle-double-right ms-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
};

export default AddRedeem;
